import { createStyles } from 'antd-style'

import bg from './assets/bg.webp'
import { LoginFooter } from './components/Footer'
import { LoginScan } from './components/Scan'
import { LoginTabs } from './components/Tabs'

const useStyles = createStyles(({ css, token, responsive, stylish }) => {
  return {
    wrapper: {
      paddingBlockEnd: 96,
      backgroundImage: `
      linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 32%,
        rgba(152, 171, 240, 0.33) 68%,
        rgba(71, 105, 228, 0.6) 100%
      )
      `
    },
    bg: {
      position: 'relative',
      height: 645,
      margin: 'auto',
      backgroundImage: `url(${bg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center 0',
      backgroundRepeat: 'no-repeat'
    },
    box: {
      position: 'absolute',
      top: 128,
      right: '10%',
      zIndex: token.zIndexPopupBase,
      paddingInline: token.paddingMD,
      backgroundColor: token.colorBgBase,
      borderRadius: token.borderRadius,
      boxShadow: token.boxShadow
    }
  }
})

export const LoginPage = () => {
  const { styles } = useStyles()

  return (
    <div className={styles.wrapper}>
      <div className={styles.bg}>
        <div className={styles.box}>
          <LoginTabs />
          <LoginScan />
          <LoginFooter />
        </div>
      </div>
    </div>
  )
}
